export const COMPLIANCE_IMPACT_ANALYSIS_GET_SUMMARY = 'COMPLIANCE_IMPACT_ANALYSIS_GET_SUMMARY';
export const COMPLIANCE_IMPACT_ANALYSIS_GET_SUMMARY_SUCCESS = 'COMPLIANCE_IMPACT_ANALYSIS_GET_SUMMARY_SUCCESS';
export const COMPLIANCE_IMPACT_ANALYSIS_GET_SUMMARY_FAIL = 'COMPLIANCE_IMPACT_ANALYSIS_GET_SUMMARY_FAIL';

export const COMPLIANCE_IMPACT_ANALYSIS_GET_SUMMARY_CLEAR = 'COMPLIANCE_IMPACT_ANALYSIS_GET_SUMMARY_CLEAR';
